// actions/permissionsActions.js
import axiosInstance from '../axiosInstance';
import { Url } from './constantUrl';
import getHeaders from './getHeaders';
import { HTTP_STATUS } from '../constants/httpstatus/HttpsStatus';
import * as types from './types';
import { errorHandler } from './error/errorHandler.action';
import {
    FETCH_PERMISSIONS_REQUEST,
    FETCH_PERMISSIONS_SUCCESS,
    FETCH_PERMISSIONS_FAILURE,
    GET_STATES_REQUEST,
    GET_STATES_SUCCESS,
    GET_STATES_FAILURE,
    GET_ROLE_REQUEST,
    GET_ROLE_SUCCESS,
    GET_ROLE_FAILURE,
    CREATE_ROLE_REQUEST,
    CREATE_ROLE_SUCCESS,
    CREATE_ROLE_FAILURE,
    DELETE_ROLE_REQUEST,
    DELETE_ROLE_SUCCESS,
    DELETE_ROLE_FAILURE,
    GET_ROLE_DETAIL_SUCCESS,
    GET_ROLE_DETAIL_FAILURE,
    UPDATE_ROLE_PERMISSION_REQUEST,
    UPDATE_ROLE_PERMISSION_SUCCESS,
    UPDATE_ROLE_PERMISSION_FAILURE,
} from './types';
import { NotificationManager } from 'react-notifications';

// Action to fetch permissions data
export const fetchPermissions = () => async (dispatch) => {
    const API_URL = localStorage.getItem('countryBackendUrl');
    const url = API_URL + Url.ROLES_PERMISSION;

    let options = {
        method: 'GET',
        headers: getHeaders(),
        url,
    };

    dispatch({ type: FETCH_PERMISSIONS_REQUEST });

    try {
        const response = await axiosInstance(options);

        if (response.status === HTTP_STATUS.SUCCESS) {
            dispatch({
                type: FETCH_PERMISSIONS_SUCCESS,
                payload: response?.data,
            });
        } else {
            throw new Error('Failed to fetch permissions: Invalid response status');
        }
    } catch (error) {
        dispatch({
            type: FETCH_PERMISSIONS_FAILURE,
            payload: error?.message || 'Failed to fetch permissions',
        });
    }
};

// Create Role Action
export const createRoleAction = (roleData) => async (dispatch) => {
    const API_URL = localStorage.getItem('countryBackendUrl');
    const url = API_URL + Url.CREATE_ROLE;

    let options = {
        method: 'POST',
        headers: getHeaders(),
        url,
        data: roleData,
    };

    dispatch({ type: CREATE_ROLE_REQUEST });

    try {
        const response = await axiosInstance(options);
        if (response?.status === HTTP_STATUS.SUCCESS) {
            dispatch({ type: CREATE_ROLE_SUCCESS, payload: response?.data });
            return { status: response?.status, message: response?.data?.message };
        } 
        else {
            return
        }
    } catch (error) {
        NotificationManager.error(error?.response?.data?.error?.role[0])
        dispatch({ type: CREATE_ROLE_FAILURE, payload: error.message || 'Failed to create role' });
    }
};

//get roles api
export const loginRolesAction = (language_id) => async (dispatch) => {
    const API_URL = localStorage.getItem('countryBackendUrl');
    let url = `${API_URL}${Url.LOGIN_ROLE}?lang_id=${language_id}`;

    const options = { method: 'GET', url };

    try {
        dispatch({ type: 'GET_ROLE_REQUEST' });

        const response = await axiosInstance(options);

        if (response.status === HTTP_STATUS.SUCCESS) {
            dispatch({ type: 'GET_ROLE_SUCCESS', payload: response.data });
            return response;
        } else {
            dispatch({ type: 'GET_ROLE_FAILURE', error: 'Failed to fetch roles' });
            return null;
        }
    } catch (error) {
        dispatch({ type: 'GET_ROLE_FAILURE', error: error?.message });
        errorHandler(error);
    }
};

//get states
export const getStateAction = (roleId) => async (dispatch) => {
    const API_URL = localStorage.getItem('countryBackendUrl');
    let url = `${API_URL}${Url.GET_STATES}`;
    
    if (roleId) {
        url += `?role_id=${roleId}`;
    }

    let options = {
        method: 'GET',
        headers: getHeaders(),
        url,
    };
    dispatch({ type: GET_STATES_REQUEST });

    try {
        const response = await axiosInstance(options);

        if (response.status === HTTP_STATUS.SUCCESS) {
            dispatch({
                type: GET_STATES_SUCCESS,
                payload: response?.data?.data,
            });
        } else {
            throw new Error('Failed to fetch permissions: Invalid response status');
        }
    } catch (error) {
        dispatch({
            type: GET_STATES_FAILURE,
            payload: error?.message || 'Failed to fetch permissions',
        });
    }

}

//delete roles and permission
export const deleteRoleAction = (roleId) => async (dispatch) => {
    const API_URL = localStorage.getItem('countryBackendUrl');
    const url = `${API_URL}${Url.DELETE_ROLE}/${roleId}`;

    const options = {
        method: 'DELETE',
        headers: getHeaders(),
        url,
    };

    dispatch({ type: DELETE_ROLE_REQUEST });

    try {
        const response = await axiosInstance(options);

        if (response.status === HTTP_STATUS.SUCCESS) {
            dispatch({
                type: DELETE_ROLE_SUCCESS,
                payload: response?.data?.message,
            });
            return { status: response?.status, message: response?.data?.message };
        }
        throw new Error('Failed to delete role: Invalid response status');
    } catch (error) {
        NotificationManager.error(error?.response?.data?.error)
        dispatch({
            type: DELETE_ROLE_FAILURE,
            payload: error.response?.data?.message || error?.message,
        });
        return { status: error?.response?.status || 500, message: error?.message };
    }
};

// Get role details action
export const getRoleDetails = (roleId) => async (dispatch) => {
    const API_URL = localStorage.getItem('countryBackendUrl');
    const url = `${API_URL}${Url.GET_ROLE_DETAILS}/${roleId}`;

    const options = {
        method: 'GET',
        headers: getHeaders(),
        url,
    };

    try {
        const response = await axiosInstance(options);

        if (response?.status === HTTP_STATUS.SUCCESS) {
            dispatch({
                type: GET_ROLE_DETAIL_SUCCESS,
                payload: response?.data?.data,
            });

            return { status: response?.status, data: response?.data?.data };
        } else {
            throw new Error('Failed to fetch role details: Invalid response status');
        }
    } catch (error) {
        dispatch({
            type: GET_ROLE_DETAIL_FAILURE,
            payload: error?.response?.data?.message || error?.message,
        });

        return {
            status: error?.response?.status || 500,
            message: error?.response?.data?.message || 'Failed to fetch role details'
        };
    }
};

// Update Role Action
export const updateRoleDetailAction = (roleId, roleData) => async (dispatch) => {
    const API_URL = localStorage.getItem('countryBackendUrl');
    const url = `${API_URL}${Url.UPDATE_ROLE_DETAILS}/${roleId}`;

    const options = {
        method: 'PUT',
        headers: getHeaders(),
        url,
        data: roleData,
    };

    try {
        const response = await axiosInstance(options);

        if (response?.status === HTTP_STATUS.SUCCESS) {
            dispatch({
                type: UPDATE_ROLE_PERMISSION_SUCCESS,
                payload: response?.data,
            });

            return { status: response?.status, message: response?.data?.message };
        } else {
            throw new Error('Failed to update role: Invalid response status');
        }
    } catch (error) {
        dispatch({
            type: UPDATE_ROLE_PERMISSION_FAILURE,
            payload: error?.message || 'Failed to update role',
        });

        return { status: error?.response?.status || 500, message: error?.message };
    }
};
